import React from 'react'
import TickedIcon from 'Assets/Images/icons/ticked'
import UntickedIcon from 'Assets/Images/icons/unticked'

export const TickedUnstyled = props => (
  <div className={props.className}>
    {props.ticked ? <TickedIcon /> : <UntickedIcon />}
  </div>
)
